import { useTranslation } from "@sagot/i18n";
import { ChoiceChips, Skeleton } from "@sagot/ui";
import { useId } from "react";
import { useAudiences } from "../shared/use-shared-queries";

interface AudiencePickerProps {
  value: readonly number[];
  onChange: (next: number[]) => void;
  error?: string | undefined;
  label?: string;
}

/** Multi-select chips of the tenant's audience labels (`audiences smallint[]`, DEC-010). */
export function AudiencePicker({ value, onChange, error, label }: AudiencePickerProps) {
  const { t } = useTranslation();
  const audiences = useAudiences();
  const labelId = useId();
  const hintId = useId();
  const heading = label ?? t("deployKnowledge.knowledge.add.audiences");
  return (
    <div>
      <p id={labelId} className="label">
        {heading}
      </p>
      {audiences.data ? (
        <ChoiceChips
          multiple
          aria-label={heading}
          value={value.map(String)}
          onValueChange={(next) => { onChange(next.map(Number).sort((a, b) => a - b)); }}
          options={audiences.data.map((audience) => ({ value: String(audience.code), label: audience.label }))}
        />
      ) : (
        <div className="flex gap-2" aria-hidden="true">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-20" />
        </div>
      )}
      <p id={hintId} className="hint">
        {t("deployKnowledge.knowledge.add.audiencesHint")}
      </p>
      {error ? (
        <p className="mt-1.5 text-xs font-semibold text-danger" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
